import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Nom016Documentacion() {
  return <CategoryPage category="nom016Documentacion" pageTitle="Documentación" />;
}

export default Nom016Documentacion;
